import { render, staticRenderFns } from "./OrderPackingDetail.vue?vue&type=template&id=6a34fef2&"
import script from "./OrderPackingDetail.vue?vue&type=script&lang=js&"
export * from "./OrderPackingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports